import _ from 'lodash';

export const checkShowField = (selectedProviderServiceId, providerServiceIdParam, field) => {
  if (selectedProviderServiceId) {
    if (providerServiceIdParam?.options[selectedProviderServiceId]) {
      const { shown_fields } = providerServiceIdParam.options[selectedProviderServiceId];
      if (shown_fields) {
        const { name } = field;
        return shown_fields.includes(name);
      }
    }
    return false;
  }
  return false;
};

export const createDefaultCustomFields = (fields) => {
  if (fields) {
    const customField = {};
    Object.keys(fields).forEach((key) => {
      if (fields[key].field_type === 'select' && key !== 'provider_service_id' && _.isObject(fields[key].list)) {
        if (fields[key].list.hasOwnProperty('')) {
          customField[key] = '';
        } else {
          const firstItemKey = Object.keys(fields[key].list)[0];
          if (firstItemKey) {
            customField[key] = firstItemKey;
          } else {
            customField[key] = null;
          }
        }
      } else {
        if (key !== 'provider_service_id') {
          customField[key] = null;
        }
      }
    })
    return customField;
  }
  return {}
};
